import { makeStyles } from '@material-ui/core';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: colors.darkestBlue,
    transition: 'color 250ms',
    '&:disabled': {
      color: colors.lightGray,
      '& svg': {
        '& path': {
          fill: colors.lightGray,
        },
      },
    },
    '&:hover': {
      color: colors.darkestBlue,
      backgroundColor: 'transparent',
      '& svg': {
        '& path': {
          transition: 'fill 250ms',
          color: colors.darkestBlue,
        },
      },
    },
  },
}));
